import { Container, Paper, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  completed: boolean;
}

const SurveyError: React.FC<Props> = ({ completed }) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <Container maxWidth="sm">
      <Paper className={classes.paper} elevation={1}>
        <Typography variant="h5" align="center">
          {completed ? t('surveyCompletedAlready') : t('surveyNotFound')}
        </Typography>
      </Paper>
    </Container>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(5, 4),
    borderRadius: theme.spacing(1.5),
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3, 2),
    },
  },
}));

export default React.memo(SurveyError);
